import { TransactionFeatureToggles } from "@/modules/transaction/common/enum";
import { useGetTransactionTypesQuery } from "@/modules/transaction/services";
import { OperationRoutes } from "@/shared/common/constants";
import type { CloudflareAsset } from "@/shared/common/enums";
import { ActionItem, EmptyOrErrorContent } from "@/shared/components";
import { useAppSelector } from "@/shared/hooks";
import { Spinner } from "@ab.uitools/ui-library/components/Spinner";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export const Transfers = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { toggles, isLoaded } = useAppSelector((state) => state.featureToggle);

  const { data: transactions, isFetching } = useGetTransactionTypesQuery({}, {
    refetchOnMountOrArgChange: true,
    selectFromResult: ({ data, isFetching }) => ({
      isFetching,
      data: data?.filter((transactionType) => {
        return toggles?.[TransactionFeatureToggles[transactionType as keyof typeof TransactionFeatureToggles]];
      }),
    })
  });

  return (
    <div className="mb-32 transfer">
      {isFetching || !isLoaded ? (
        <div
          className="full-width flexbox justify-content--center loader-wrapper">
          <Spinner isFullScreen={false} size="large"/>
        </div>
      ) : (
        transactions?.length ? (
          <div className="transfer-grid">
            {transactions?.map((transactionType) => (
              <div key={transactionType}>
                <ActionItem
                  title={t(`banking.transactions.${transactionType}`)}
                  icon={transactionType as CloudflareAsset}
                  onClick={() => navigate(OperationRoutes[transactionType])}
                />
              </div>
            ))}
          </div>
        ) : (
          <div className="empty-content-wrapper pt-40">
            <EmptyOrErrorContent
              isShowButton={false}
              title={t("transaction.types.emptyTitle")}
            />
          </div>
        ))}
    </div>
  );
};
